// src/hooks/useIsPWA.js
// Hook pour détecter si l'app est en mode PWA standalone
import { useState, useEffect } from 'react'

/**
 * Détecte si l'application est lancée en mode PWA (standalone)
 * @returns {object} { isPWA, isMobile, isPWAMobile }
 */
export const useIsPWA = () => {
  const [isPWA, setIsPWA] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Vérifier si on est en mode standalone (PWA installée)
    const checkPWA = () => {
      const isStandalone =
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true || // iOS Safari
        document.referrer.includes('android-app://') // Android TWA

      setIsPWA(isStandalone)
    }

    // Vérifier si on est sur mobile/tablette
    const checkMobile = () => {
      const mobile = window.innerWidth < 992 // lg breakpoint
      setIsMobile(mobile)
    }

    // Check initial
    checkPWA()
    checkMobile()

    // Écouter les changements de display-mode
    const mediaQuery = window.matchMedia('(display-mode: standalone)')
    const handleDisplayModeChange = (e) => setIsPWA(e.matches)

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleDisplayModeChange)
    } else {
      // Fallback pour anciens navigateurs
      mediaQuery.addListener(handleDisplayModeChange)
    }

    // Écouter les changements de taille
    window.addEventListener('resize', checkMobile)

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleDisplayModeChange)
      } else {
        mediaQuery.removeListener(handleDisplayModeChange)
      }
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  return {
    isPWA,
    isMobile,
    // Mode PWA sur mobile = afficher bottom nav
    isPWAMobile: isPWA && isMobile,
    // Mode mobile (PWA ou non) pour adapter l'UI
    shouldShowBottomNav: isMobile,
  }
}

export default useIsPWA
